/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC725, ERC725Interface } from "../ERC725";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "operation",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "ContractCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "value",
        type: "bytes",
      },
    ],
    name: "DataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "operation",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Executed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_operation",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keys",
        type: "bytes32[]",
      },
    ],
    name: "getData",
    outputs: [
      {
        internalType: "bytes[]",
        name: "values",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_keys",
        type: "bytes32[]",
      },
      {
        internalType: "bytes[]",
        name: "_values",
        type: "bytes[]",
      },
    ],
    name: "setData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b506040516200170d3803806200170d833981016040819052620000349162000238565b8080620000496000546001600160a01b031690565b6001600160a01b0316816001600160a01b03161462000078576200007881620000d160201b620008941760201c565b6200008a632260147f60e11b62000164565b506000546001600160a01b03828116911614620000b757620000b781620000d160201b620008941760201c565b620000c9635a988c0f60e01b62000164565b50506200026a565b600054600160a01b900460ff1615620001435760405162461bcd60e51b815260206004820152602960248201527f4f776e61626c653a206f776e65722063616e206f6e6c7920626520696e69746960448201526861746564206f6e636560b81b60648201526084015b60405180910390fd5b6000805460ff60a01b1916600160a01b1790556200016181620001e8565b50565b6001600160e01b03198082161415620001c05760405162461bcd60e51b815260206004820152601c60248201527f4552433136353a20696e76616c696420696e746572666163652069640000000060448201526064016200013a565b6001600160e01b0319166000908152600160208190526040909120805460ff19169091179055565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6000602082840312156200024b57600080fd5b81516001600160a01b03811681146200026357600080fd5b9392505050565b611493806200027a6000396000f3fe6080604052600436106100705760003560e01c80634e3e6e9c1161004e5780634e3e6e9c146100ec578063715018a6146101195780638da5cb5b1461012e578063f2fde38b1461015657600080fd5b806301ffc9a71461007557806314a6e293146100aa57806344c028fe146100cc575b600080fd5b34801561008157600080fd5b50610095610090366004611153565b610176565b60405190151581526020015b60405180910390f35b3480156100b657600080fd5b506100ca6100c5366004611028565b6101b6565b005b6100df6100da36600461117d565b61029e565b6040516100a191906112ea565b3480156100f857600080fd5b5061010c610107366004610ff3565b61070f565b6040516100a19190611259565b34801561012557600080fd5b506100ca6107c3565b34801561013a57600080fd5b506000546040516001600160a01b0390911681526020016100a1565b34801561016257600080fd5b506100ca610171366004610fd1565b6107f9565b60006301ffc9a760e01b6001600160e01b0319831614806101b057506001600160e01b0319821660009081526001602052604090205460ff165b92915050565b6000546001600160a01b031633146101e95760405162461bcd60e51b81526004016101e0906112fd565b60405180910390fd5b80518251146102495760405162461bcd60e51b815260206004820152602660248201527f4b657973206c656e677468206e6f7420657175616c20746f2076616c756573206044820152650d8cadccee8d60d31b60648201526084016101e0565b60005b82518110156102995761029183828151811061026a5761026a611431565b602002602001015183838151811061028457610284611431565b602002602001015161091c565b60010161024c565b505050565b6000546060906001600160a01b031633146102cb5760405162461bcd60e51b81526004016101e0906112fd565b60005a90508661036457610318868686868080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250879250610978915050565b915084866001600160a01b0316887f1f920dbda597d7bf95035464170fa58d0a4b57f13a1c315ace6793b9f63688b887876040516103579291906112bb565b60405180910390a4610705565b60038714156103af576103188685858080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152508692506109f9915050565b60048714156104e257600080546001600160a01b031690506104098786868080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250879250610a74915050565b925085876001600160a01b0316897f1f920dbda597d7bf95035464170fa58d0a4b57f13a1c315ace6793b9f63688b888886040516104489291906112bb565b60405180910390a4806001600160a01b031661046c6000546001600160a01b031690565b6001600160a01b0316146104dc5760405162461bcd60e51b815260206004820152603160248201527f44656c65676174652063616c6c206973206e6f7420616c6c6f77656420746f206044820152706d6f6469667920746865206f776e65722160781b60648201526084016101e0565b50610705565b600187141561059e57600061052d8686868080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250610ace92505050565b6040516bffffffffffffffffffffffff19606083901b166020820152909150603401604051602081830303815290604052925085816001600160a01b0316897f01c42bd7e97a66166063b02fce6924e6656b6c2c61966630165095c4fb0b7b2f60405160405180910390a450610705565b60028714156106c65760006105f585858080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152506105f092506020915088905061139f565b610b30565b9050600061064486868080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920182905250925061063f9150602090508961139f565b610b8e565b90506000610653888484610c9b565b6040516bffffffffffffffffffffffff19606083901b166020820152909150603401604051602081830303815290604052945087816001600160a01b03168b7f01c42bd7e97a66166063b02fce6924e6656b6c2c61966630165095c4fb0b7b2f60405160405180910390a4505050610705565b60405162461bcd60e51b815260206004820152601460248201527357726f6e67206f7065726174696f6e207479706560601b60448201526064016101e0565b5095945050505050565b6060815167ffffffffffffffff81111561072b5761072b611447565b60405190808252806020026020018201604052801561075e57816020015b60608152602001906001900390816107495790505b50905060005b82518110156107bd5761078f83828151811061078257610782611431565b6020026020010151610da5565b8282815181106107a1576107a1611431565b60200260200101819052506107b68160010190565b9050610764565b50919050565b6000546001600160a01b031633146107ed5760405162461bcd60e51b81526004016101e0906112fd565b6107f76000610e47565b565b6000546001600160a01b031633146108235760405162461bcd60e51b81526004016101e0906112fd565b6001600160a01b0381166108885760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016101e0565b61089181610e47565b50565b600054600160a01b900460ff16156109005760405162461bcd60e51b815260206004820152602960248201527f4f776e61626c653a206f776e65722063616e206f6e6c7920626520696e69746960448201526861746564206f6e636560b81b60648201526084016101e0565b6000805460ff60a01b1916600160a01b17905561089181610e47565b6000828152600260209081526040909120825161093b92840190610eaf565b50817fece574603820d07bc9b91f2a932baadf4628aabcb8afba49776529c14a6104b28260405161096c91906112ea565b60405180910390a25050565b6060600080866001600160a01b0316848787604051610997919061123d565b600060405180830381858888f193505050503d80600081146109d5576040519150601f19603f3d011682016040523d82523d6000602084013e6109da565b606091505b5091509150816109ef576109ed81610e97565b505b9695505050505050565b6060600080856001600160a01b03168486604051610a17919061123d565b6000604051808303818686fa925050503d8060008114610a53576040519150601f19603f3d011682016040523d82523d6000602084013e610a58565b606091505b509150915081610a6b5761070581610e97565b95945050505050565b6060600080856001600160a01b03168486604051610a92919061123d565b6000604051808303818686f4925050503d8060008114610a53576040519150601f19603f3d011682016040523d82523d6000602084013e610a58565b600081516020830184f090506001600160a01b0381166101b05760405162461bcd60e51b815260206004820152601960248201527f436f756c64206e6f74206465706c6f7920636f6e74726163740000000000000060448201526064016101e0565b6000610b3d826020611387565b83511015610b855760405162461bcd60e51b8152602060048201526015602482015274746f427974657333325f6f75744f66426f756e647360581b60448201526064016101e0565b50016020015190565b606081610b9c81601f611387565b1015610bdb5760405162461bcd60e51b815260206004820152600e60248201526d736c6963655f6f766572666c6f7760901b60448201526064016101e0565b610be58284611387565b84511015610c295760405162461bcd60e51b8152602060048201526011602482015270736c6963655f6f75744f66426f756e647360781b60448201526064016101e0565b606082158015610c485760405191506000825260208201604052610c92565b6040519150601f8416801560200281840101858101878315602002848b0101015b81831015610c81578051835260209283019201610c69565b5050858452601f01601f1916604052505b50949350505050565b60008084471015610cee5760405162461bcd60e51b815260206004820152601d60248201527f437265617465323a20696e73756666696369656e742062616c616e636500000060448201526064016101e0565b8251610d3c5760405162461bcd60e51b815260206004820181905260248201527f437265617465323a2062797465636f6465206c656e677468206973207a65726f60448201526064016101e0565b8383516020850187f590506001600160a01b038116610d9d5760405162461bcd60e51b815260206004820152601960248201527f437265617465323a204661696c6564206f6e206465706c6f790000000000000060448201526064016101e0565b949350505050565b6000818152600260205260409020805460609190610dc2906113e6565b80601f0160208091040260200160405190810160405280929190818152602001828054610dee906113e6565b8015610e3b5780601f10610e1057610100808354040283529160200191610e3b565b820191906000526020600020905b815481529060010190602001808311610e1e57829003601f168201915b50505050509050919050565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b8051606090156100705781518083602001fd5b919050565b828054610ebb906113e6565b90600052602060002090601f016020900481019282610edd5760008555610f23565b82601f10610ef657805160ff1916838001178555610f23565b82800160010185558215610f23579182015b82811115610f23578251825591602001919060010190610f08565b50610f2f929150610f33565b5090565b5b80821115610f2f5760008155600101610f34565b80356001600160a01b0381168114610eaa57600080fd5b600082601f830112610f7057600080fd5b81356020610f85610f8083611363565b611332565b80838252828201915082860187848660051b8901011115610fa557600080fd5b60005b85811015610fc457813584529284019290840190600101610fa8565b5090979650505050505050565b600060208284031215610fe357600080fd5b610fec82610f48565b9392505050565b60006020828403121561100557600080fd5b813567ffffffffffffffff81111561101c57600080fd5b610d9d84828501610f5f565b600080604080848603121561103c57600080fd5b833567ffffffffffffffff8082111561105457600080fd5b61106087838801610f5f565b945060209150818601358181111561107757600080fd5b8601601f8101881361108857600080fd5b8035611096610f8082611363565b8082825285820191508584018b878560051b87010111156110b657600080fd5b60005b84811015611141578135878111156110d057600080fd5b8601603f81018e136110e157600080fd5b88810135888111156110f5576110f5611447565b611107601f8201601f19168b01611332565b8181528f8c83850101111561111b57600080fd5b818c84018c83013760009181018b019190915285525092870192908701906001016110b9565b50989b909a5098505050505050505050565b60006020828403121561116557600080fd5b81356001600160e01b031981168114610fec57600080fd5b60008060008060006080868803121561119557600080fd5b853594506111a560208701610f48565b935060408601359250606086013567ffffffffffffffff808211156111c957600080fd5b818801915088601f8301126111dd57600080fd5b8135818111156111ec57600080fd5b8960208285010111156111fe57600080fd5b9699959850939650602001949392505050565b600081518084526112298160208601602086016113b6565b601f01601f19169290920160200192915050565b6000825161124f8184602087016113b6565b9190910192915050565b6000602080830181845280855180835260408601915060408160051b870101925083870160005b828110156112ae57603f1988860301845261129c858351611211565b94509285019290850190600101611280565b5092979650505050505050565b60208152816020820152818360408301376000818301604090810191909152601f909201601f19160101919050565b602081526000610fec6020830184611211565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b604051601f8201601f1916810167ffffffffffffffff8111828210171561135b5761135b611447565b604052919050565b600067ffffffffffffffff82111561137d5761137d611447565b5060051b60200190565b6000821982111561139a5761139a61141b565b500190565b6000828210156113b1576113b161141b565b500390565b60005b838110156113d15781810151838201526020016113b9565b838111156113e0576000848401525b50505050565b600181811c908216806113fa57607f821691505b602082108114156107bd57634e487b7160e01b600052602260045260246000fd5b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052604160045260246000fdfea26469706673582212206de50131d7aaef123955720280ace6d4a30e6302bcf7b70568da567f2fb2188364736f6c63430008060033";

export class ERC725__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _newOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC725> {
    return super.deploy(_newOwner, overrides || {}) as Promise<ERC725>;
  }
  getDeployTransaction(
    _newOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_newOwner, overrides || {});
  }
  attach(address: string): ERC725 {
    return super.attach(address) as ERC725;
  }
  connect(signer: Signer): ERC725__factory {
    return super.connect(signer) as ERC725__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC725Interface {
    return new utils.Interface(_abi) as ERC725Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC725 {
    return new Contract(address, _abi, signerOrProvider) as ERC725;
  }
}
